




































































import { Alerts } from '@/dataLayer/Alerts'
import IAlert from '@/viewModel/IAlert'
import AlertList from '@/components/alert/AlertList.vue'
import { Vue } from 'vue-property-decorator'
import ScreenTile from '../components/ScreenTile.vue'
import '../styles/alert-detail.css'
import Format from '@/util/Format'
import IAlertTag from '@/viewModel/IAlertTag'
import moment from 'moment'

export default Vue.extend({
  data: function () {
    return {
      alert: {} as IAlert,
      loading: true,
      canLoadImage: false,
      tagsArray: [] as string[],
      relatedAlerts: [] as IAlert[],
      alertTags: [] as IAlertTag[],
      formatDateFn: (strDate: string) => strDate,
    }
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  async mounted() {
    await this.loadAlert()
    await this.loadAlertTags()
    this.loading = false

    try {
      const canLoadImage = await fetch(this.alert.imageUrl)

      if (canLoadImage.ok) this.canLoadImage = true
    } catch {}
  },
  watch: {
    id: function () {
      this.loadAlert()
    },
  },
  filters: {
    formatDate(date) {
      return moment(date).format('yyyy-MM-DD')
    },
  },
  created() {
    this.formatDateFn = Format.formatDate
  },
  computed: {
    applicableTags: function () {
      return this.alertTags.filter((tag) => this.alert.tags.includes(tag.id))
    },

    showEndDate: function () {
      return (
        this.alertDate &&
        moment(this.alert.endDate).format('yyyy-MM-DD') !==
          moment(this.alert.startDate).format('yyyy-MM-DD')
      )
    },
  },
  methods: {
    loadAlert: async function () {
      this.loading = true

      this.alert = await Alerts.loadAlert(this.id)

      if(this.alert.alertRead == false)
      {
        await Alerts.markRead(this.id)
      }

      const relatedAlertsViewModel = await Alerts.loadAlerts(
        this.alert.tags,
        false,
        true
      ) // show any article that has at least 1 checkbox matching
      this.relatedAlerts = relatedAlertsViewModel.alerts.filter(
        (alert: IAlert) => alert.id !== this.alert.id
      )
    },
    loadAlertTags: async function () {
      this.alertTags = await Alerts.loadAlertTags()
    },
    markRead: async function () {
      await Alerts.markRead(this.alert.id)
    },
    markUnRead: async function () {
      await Alerts.markUnRead(this.alert.id)
      this.$router.push('/updates-and-alerts')
    },
    returnToUpdateAlerts() {
      this.$router.push('/updates-and-alerts')
    },
  },
  components: { ScreenTile, AlertList },
})
